// import { Constants } from '../../shared/constants';
// import { Box, Button, Typography } from '@mui/material';
// import useResponsive from '../../shared/utils/Responsive';
// import { KnowMoreButton } from '../../shared/utils/CustomButton';
// import { useNavigate } from 'react-router-dom';




// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Autoplay, EffectFade, Navigation } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';
// import 'swiper/css/navigation';




// const Slide2 = () => {
//   const isSmallScreen = useResponsive("md")
//   const navigate = useNavigate();
//   return (
//     <>
//       <Box
//         sx={{
//           position: "relative",
//           backgroundImage: isSmallScreen
//             ? `url(${Constants.customImages.HeroSectionImgJpg})`
//             : `url(${Constants.customImages.HeroCaraouselImg2})`,
//           backgroundSize: "cover",
//           backgroundPosition: "bottom",
//           backgroundRepeat: "no-repeat",
//           padding: { xs: "20px", sm: "40px", md: "120px 40px" },
//           borderRadius: "40px",
//           overflow: "hidden",
//           height:"180px"
//         }}
//       >

//         {
//           !isSmallScreen && (
//             <Box width={"30%"} sx={{ position: "absolute", display: "flex", justifyContent: "start", alignItems: "end", flexDirection: "column", right: "15px", bottom: "15px" }}>
//               <KnowMoreButton onClick={() => { navigate("/Courses") }} text={"Know More"} />
//               <Typography variant='body2' lineHeight={"15px"} fontSize={"12px"} color='primary.main' textAlign={"end"} mt={1} >MySkill is an educational institution that provides quality learning experiences for students across various academic levels</Typography>
//             </Box>
//           )
//         }
//       </Box>
//     </>
//   );
// }







// const HeroSection = ({ content}) => {
//   const slides = [
//     // <Slide1 />,
//     <Slide2 />
//   ];
//   return (
//     <Swiper
//       modules={[Pagination, Autoplay, EffectFade, Navigation]}
//       effect="fade"
//       spaceBetween={10}
//       slidesPerView={1}
//       pagination={{ clickable: true }}
//       autoplay={{ delay: 3000, disableOnInteraction: false }}
//       loop
//       navigation={{ nextEl: ".custom-swiper-next", prevEl: ".custom-swiper-prev" }}
//       style={{
//         minHeight: "100%",
//         borderRadius: "40px",
//         position: "relative",
//       }}

//     >
//       {slides.map((slide, index) => (
//         <SwiperSlide key={index}>
//           {slide}
//         </SwiperSlide>
//       ))}
//     </Swiper>
//   )
// }

// export default HeroSection;






// // const Slide1 = () => {
// //   const isSmallScreen = useResponsive("md")
// //   const navigate = useNavigate();
// //   return (
// //     <>
// //       <Box
// //         sx={{
// //           position: "relative",
// //           backgroundImage: isSmallScreen
// //             ? `url(${Constants.customImages.HeroSectionImgJpg})`
// //             : `url(${Constants.customImages.HeroSectionImg})`,
// //           backgroundSize: "cover",
// //           backgroundPosition: "bottom",
// //           backgroundRepeat: "no-repeat",
// //           padding: { xs: "20px", sm: "40px", md: "120px 40px" },
// //           borderRadius: "40px",
// //           overflow: "hidden",
// //             height:"180px"
// //         }}
// //       >
// //         <Typography variant='h2' color='primary.main' sx={{ textAlign: { xs: "center", lg: "start" } }}>
// //           Unlock Fun + Learning! Join our summer camp now
// //         </Typography>
// //         <Typography variant='body1' color='primary.main' my={2} textAlign={{ xs: "center", lg: "start" }} sx={{ width: { xs: "100%", md: "70%", } }}>
// //           {
// //             isSmallScreen ? "Let your child explore summer camp activities with a difference At MySkill." : "Let your child explore summer camp activities with a difference. At MySkill, we provide learning spanning multiple disciplines with focus on holistic development of each child. We are now available in apartments also."
// //           }
// //         </Typography>
// //         <Box sx={{ display: "flex", justifyContent: { xs: "center", lg: "start" } }}>
// //           <Button variant='gost' onClick={() => { navigate("/ContactUs") }}>
// //             Contact Us
// //           </Button>
// //         </Box>
// //         {
// //           !isSmallScreen && (
// //             <Box width={"30%"} sx={{ position: "absolute", display: "flex", justifyContent: "start", alignItems: "end", flexDirection: "column", right: "15px", bottom: "15px" }}>
// //               <KnowMoreButton onClick={() => { navigate("/Courses") }} text={"Know More"} />
// //               <Typography variant='body2' lineHeight={"15px"} fontSize={"12px"} color='primary.main' textAlign={"end"} mt={1} >MySkill is an educational institution that provides quality learning experiences for students across various academic levels</Typography>
// //             </Box>
// //           )
// //         }
// //       </Box>
// //     </>
// //   );
// // };




import { Constants } from "../../shared/constants";
import { Box, Typography } from "@mui/material";
import useResponsive from "../../shared/utils/Responsive";
import { KnowMoreButton } from "../../shared/utils/CustomButton";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import { getImageUrl } from "../../shared/utils/getImageUrl";

const HeroSection = ({content}) => {
  const navigate = useNavigate();
  const isSmallScreen = useResponsive("md");

  // 🎯 1️⃣ Define all slides in a config array
  const slides = [
    {
      id: 1,
        imageUrlSmall: Constants.customImages.HeroSectionImgJpg,
      imageUrl: Constants.customImages.HeroCaraouselImg2,
      description:
        "MySkill is an educational institution that provides quality learning experiences for students across various academic levels.",
      buttonText: "Know More",
      buttonUrl: () => navigate("/Courses"),
    },
    {
      id: 2,
      imgSmall: Constants.customImages.HeroSectionImgJpg,
      imageUrlSmall: Constants.customImages.HeroCaraouselImg2,
      description: "Empowering women through quality learning and mentorship.",
      buttonText: "Explore Programs",
      buttonUrl: () => navigate("/Programs"),
    },
  ];

  // 🎯 2️⃣ Map slides directly in Swiper
  return (
    <Swiper
      modules={[Pagination, Autoplay, EffectFade, Navigation]}
      effect="fade"
      spaceBetween={10}
      slidesPerView={1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop
      navigation={{ nextEl: ".custom-swiper-next", prevEl: ".custom-swiper-prev" }}
      style={{
        minHeight: "100%",
        borderRadius: "40px",
        position: "relative",
      }}
    >
      {content?.data?.carousels?.map((slide) => (
        <SwiperSlide key={slide.id}>
          <Box
            sx={{
              position: "relative",
              backgroundImage: isSmallScreen
                ? `url(${getImageUrl(slide.imageUrlSmall)})`
                : `url(${getImageUrl(slide.imageUrl)})`,
              backgroundSize: "cover",
              backgroundPosition: "bottom",
              backgroundRepeat: "no-repeat",
              padding: { xs: "20px", sm: "40px", md: "120px 40px" },
              borderRadius: "40px",
              overflow: "hidden",
              height: "402px",
            }}
          >
            {!isSmallScreen && (
              <Box
                width={"30%"}
                sx={{
                  position: "absolute",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "end",
                  flexDirection: "column",
                  right: "15px",
                  bottom: "15px",
                }}
              >
                <KnowMoreButton
                  onClick={()=>{navigate(slide.buttonUrl)}}
                  text={slide.buttonText}
                />
                <Typography
                  variant="body2"
                  lineHeight={"15px"}
                  fontSize={"12px"}
                  color="primary.main"
                  textAlign={"end"}
                  mt={1}
                >
                  {slide.description}
                </Typography>
              </Box>
            )}
          </Box>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HeroSection;



